export enum enumSasChangeBACStatus {
  'No' = 0,
  'Yes' = 1
}

export namespace enumSasChangeBACStatus {
  export function values() {
    return Object.keys(enumSasChangeBACStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
